import React from 'react';

const steps = [
  {
    number: '1',
    title: 'Application',
    desc: 'Apply anytime, we accept applications year-round.'
  },
  {
    number: '2',
    title: 'Review',
    desc: 'We’ll review your application within 3–5 business days.'
  },
  {
    number: '3',
    title: 'Selection',
    desc: 'Applications are carefully reviewed by Nusrat Ahmed and Marjan Zaman (parents of Abdullah).'
  }
];

const HowItWorksSection = () => (
  <section className="howItWorks-section" id="process">
    <h2 className="howItWorks-title">How It Works</h2>
    <p className="howItWorks-desc">
      Our process is quick and simple so you can focus on your studies.
    </p>
    <div className="howItWorks-steps">
      {steps.map(({number, title, desc}, idx) => (
        <div key={idx} className="howItWorks-step">
          <div className="howItWorks-stepNumber">{number}</div>
          {idx < steps.length - 1 && <div className="howItWorks-stepLine"></div>}
          <h3 className="howItWorks-stepTitle">{title}</h3>
          <p className="howItWorks-stepDesc">{desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorksSection;
